<template>
<v-container>
  <v-row>
    <v-col>
    <v-card color="primary" dark>
      <v-tabs
        v-model="tab"
        background-color="transparent"
        color="white"
        show-arrows
        grow
      >
        <v-tabs-slider color="#0897d7"></v-tabs-slider>
        <v-tab
          v-for="item in items"
          :key="item"
        >
          {{ item }}
        </v-tab>
      </v-tabs>

      <!-- TABS -->
      <v-tabs-items v-model="tab">

        <!-- Users -->
        <v-tab-item>
          <v-card
            flat
          >
            <v-card-text>
              <v-data-table
                :headers="headers"
                :items="users"
                :items-per-page="5"
                :calculate-widths="true"
                item-key="station"
                class="elevation-1"
                @click:row="handleClick"
                :footer-props="{
                  showFirstLastPage: true,
                  firstIcon: 'mdi-arrow-collapse-left',
                  lastIcon: 'mdi-arrow-collapse-right',
                  prevIcon: 'mdi-minus',
                  nextIcon: 'mdi-plus'
                }"
              >
              <template v-slot:[`item.confirmed`]="{ item }">
                <span v-if="!item.confirmed">
                  <v-btn color="primary" @click.stop="confirm(item.id)" rounded small>
                    <v-icon>
                      mdi-help
                    </v-icon>
                  </v-btn>
                </span>
                <span v-else>
                  <v-chip
                    color="success"
                  >
                    <v-icon>
                      mdi-check
                    </v-icon>
                  </v-chip>
                </span>
                </template>

              <template v-slot:[`item.role`]="{ item }">
                <v-select
                  v-model="item.role"
                  :items="positions"
                  :hide-no-data="!search"
                  label="Role"
                  auto-select-first
                  :rules="roleRequired"
                  @change="saveRole(item.id,item.role)"
                >
                </v-select>
              </template>

              <template v-slot:[`item.location`]="{ item }">
                <v-select
                  v-model="item.location"
                  :items="locations"
                  label="UPTD PSDA"
                  :hide-no-data="!searchLocation"
                  auto-select-first
                  :rules="locationRequired"
                  @change="saveLocation(item.id,item.location)"
                >
                </v-select>
              </template>

              <template v-slot:[`item.id`]="{ item }">
                <v-btn color="error" @click.stop="dialogDelete=true; selectedID=item.id; emailDelete=item.email" rounded small>
                  <v-icon>
                    mdi-delete
                  </v-icon>
                </v-btn>
              </template>

              </v-data-table>
              <v-dialog
                v-model="dialogDelete"
                max-width="500"
              >
              <v-card>
                <v-toolbar color="primary font-weight-bold" dark>
                  Delete User
                </v-toolbar>
                <v-card-text>
                  <p class="mt-2 font-weight-medium text-center mb-n2">
                    Apakah Anda yakin akan menghapus user {{emailDelete}}?
                  </p>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    text
                    @click="Delete(selectedID)"
                    color="red"
                  ><v-icon dark>
                    mdi-delete-forever
                  </v-icon>
                  Delete
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    @click="dialogDelete=false"
                    color="primary"
                  >Cancel</v-btn>
                </v-card-actions>
              </v-card>
              </v-dialog>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- Alarm -->
        <v-tab-item>
          <v-card
            flat
          >
            <v-card-text>
              <v-form ref="form" v-model="valid">
                <v-container>
                  <v-row class="my-n8">
                    <v-col>
                      <v-select
                        :items="stations"
                        label="Stasiun"
                        v-model="selectStation"
                        return-object
                        :rules="nameRules"
                        @change="change(selectStation)"
                        class="float-right"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="6"
                    >
                      <v-row>
                        <v-col class="mb-n4">
                          <v-text-field
                            v-model="station"
                            :rules="nameRules"
                            label="Station"
                            required
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col class="mb-n4">
                          <v-text-field
                            v-model="phoneNumber"
                            :rules="number"
                            label="Station Number"
                            required
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col class="my-n4">
                          <v-text-field
                            v-model="latitude"
                            :rules="nameRules"
                            label="GPS Coordinate Latitude"
                            required
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="my-n4">
                          <v-text-field
                            v-model="longitude"
                            :rules="nameRules"
                            label="GPS Coordinate Longitude"
                            required
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="my-n4">
                          <v-combobox
                            v-model="location"
                            :items="locations"
                            label="UPTD PSDA"
                            auto-select-first
                            :rules="locationRequired"
                          >
                          </v-combobox>
                        </v-col>
                      </v-row>

                      <!-- Recap Time -->
                      <v-row>
                        <v-col class="my-n4">
                          <v-dialog
                            ref="dialog"
                            v-model="modal2"
                            :return-value.sync="recapTime"
                            persistent
                            width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="recapTime"
                                label="Waktu Rekap"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-time-picker
                              v-if="modal2"
                              v-model="recapTime"
                              full-width
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="modal2 = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.dialog.save(recapTime)"
                              >
                                OK
                              </v-btn>
                            </v-time-picker>
                          </v-dialog>
                        </v-col>
                      </v-row>
                      
                      <!-- Periodical Info -->
                      <!-- <v-row>
                        <v-col class="my-n4">
                          <v-text-field
                            v-model="period"
                            :rules="nameRules"
                            label="Periode Info (menit)"
                            required
                          ></v-text-field>
                        </v-col>
                      </v-row> -->
                      

                    </v-col>

                    <v-divider
                      class="d-none d-sm-flex"
                      vertical
                    ></v-divider>

                    <v-col
                      cols="12"
                      sm="6"
                    >
                    <v-row>
                      <v-col class="mb-n4">
                        <v-text-field
                          v-model="voltage"
                          :rules="number"
                          label="Low Voltage"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <!-- mm/tick -->
                    <!-- <v-row>
                      <v-col
                        class="my-n4"
                      >
                        <v-text-field
                          v-model="tickmm"
                          :rules="number"
                          label="mm/tick"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row> -->

                    <v-row>
                      <v-col
                        class="my-n4"
                      >
                        <v-text-field
                          v-model="alarmA"
                          :rules="number"
                          label="Alarm(mm/hour)"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col
                        class="my-n4"
                      >
                        <v-text-field
                          v-model="alarmC"
                          :rules="number"
                          label="Alarm(mm/rain)"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col
                        class="my-n4"
                      >
                        <v-text-field
                          v-model="password"
                          :rules="nameRules"
                          label="Password Petugas"
                          :type="show1 ? 'text' : 'password'"
                          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                          @click:append="show1 = !show1"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>


                    <!-- Rain Stop Time -->
                    <!-- <v-row>
                      <v-col
                        class="my-n4"
                      >
                        <v-text-field
                          v-model="stoptime"
                          :rules="number"
                          label="Rain Stop Time (s)"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row> -->

                    <!-- Rain Start Tick -->
                    <!-- <v-row>
                      <v-col
                        class="my-n4"
                      >
                        <v-text-field
                          v-model="starttick"
                          :rules="number"
                          label="Rain Start Tick"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row> -->

                    </v-col>

                  </v-row>
                  <v-row>
                    <v-col>
                      <v-btn
                        color="error darken-1"
                        @click="deleteDevice(selectStation)"
                      >
                        <v-icon>
                          mdi-delete
                        </v-icon>
                        Delete Device
                      </v-btn>
                      <v-btn
                        color="success darken-1"
                        class="float-right"
                        @click="save(selectStation)"
                      >
                        Save
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>

              <br>
              <v-row>
                <v-col>
                <h2> Tukar Device</h2>
                <v-divider></v-divider>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-select
                    v-model="stationA"
                    :items="stations"
                    label="Stasiun"
                    persistent-hint
                    return-object
                    :hint="`${stationA.feedingID}`">
                  </v-select>
                </v-col>
                <v-icon>mdi-swap-horizontal</v-icon>
                <v-col>
                  <v-select
                    v-model="stationB"
                    :items="stations"
                    label="Stasiun"
                    return-object
                    persistent-hint
                    :hint ="`${stationB.feedingID}`">
                    <template v-slot:append-outer>
                      <v-btn
                        color="success darken-1"
                        @click="swapDevice(stationA,stationB)"
                      >
                        Swap
                      </v-btn>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-snackbar
            v-model="swapSnackbar"
            color="success darken-1"
            dark
            bottom>
            Device Swapped
          </v-snackbar>
        </v-tab-item>

        <!-- Notification -->
        <v-tab-item>
          <v-card
            flat
          >
            <v-card-text>
              <v-form ref="notification" v-model="valid">
                <v-container>
                  
                  <!-- Formating Notification -->
                  <v-row>
                    <v-col
                      cols="12"
                    >
                    <Mentionable
                      :keys="['@']"
                      :items="suggestions"
                      placement="bottom"
                      offset="5 100"
                    >
                      <v-textarea
                        outlined
                        name="input-7-4"
                        label="Rain Start Notification Format"
                        v-model="startNotif"
                      ></v-textarea>
                    </Mentionable>
                    </v-col>
                    <v-col
                      cols="12"
                    >
                    <Mentionable
                      :keys="['@']"
                      :items="suggestionsRain"
                      placement="bottom"
                      offset="5 100"
                    >
                      <v-textarea
                        outlined
                        name="input-7-4"
                        label="Rain Stop Notification Format"
                        v-model="stopNotif"
                      ></v-textarea>
                    </Mentionable>
                    </v-col>
                    <v-col
                      cols="12"
                    >
                    <Mentionable
                      :keys="['@']"
                      :items="suggestionsRain"
                      placement="bottom"
                      offset="5 100"
                    >
                      <v-textarea
                        outlined
                        name="input-7-4"
                        label=">92mm Notification Format"
                        v-model="notifCNotif"
                      ></v-textarea>
                    </Mentionable>
                    </v-col>
                    <v-col
                      cols="12"
                    >
                    <Mentionable
                      :keys="['@']"
                      :items="suggestionsRain"
                      placement="bottom"
                      offset="5 100"
                    >
                      <v-textarea
                        outlined
                        name="input-7-4"
                        label=">10mm Notification Format"
                        v-model="notifANotif"
                      ></v-textarea>
                    </Mentionable>
                    </v-col>
                    <v-col
                      cols="12"
                    >
                    <Mentionable
                      :keys="['@']"
                      :items="suggestions"
                      placement="bottom"
                      offset="5 100"
                    >
                      <v-textarea
                        outlined
                        name="input-7-4"
                        label="Battery Low Notification Format"
                        v-model="batteryNotif"
                      ></v-textarea>
                    </Mentionable>
                    </v-col>
                    <v-col
                      cols="12"
                    >
                    <Mentionable
                      :keys="['@']"
                      :items="suggestions"
                      placement="bottom"
                      offset="5 100"
                    >
                      <v-textarea
                        outlined
                        name="input-7-4"
                        label="Device Status Notification Format"
                        v-model="turnedOnNotif"
                      ></v-textarea>
                    </Mentionable>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <v-btn
                        color="success darken-1"
                        class="float-right"
                        @click="saveNotif()"
                      >
                        Save
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- Role Setting -->
        <v-tab-item>
          <v-card
            flat
          >
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col>
                    <h2>Add or Delete Role</h2>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-form ref="addrole">
                  <v-combobox
                    v-model="roleCombobox"
                    :items="positions"
                    :hide-no-data="!search"
                    label="Role"
                    prepend-icon="mdi-badge-account"
                    auto-select-first
                    :rules="roleRequired"
                  >
                    <template v-slot:item="{ item }">
                      {{item}}
                      <v-spacer></v-spacer>
                      <v-list-item-action @click.stop>
                        <v-btn
                          icon
                          @click.stop.prevent="deleteRole(item)"
                        >
                          <v-icon color="error">mdi-delete</v-icon>
                        </v-btn>
                      </v-list-item-action>
                    </template>
                  </v-combobox>
                </v-form>
                <v-row>
                  <v-col>
                    <h2>Notification Setting</h2>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-form ref="notif" lazy-validation>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="5"
                    >
                      <v-select
                        class="mt-4"
                        :items="positions"
                        :rules="nameRules"
                        label="Position"
                        @change="getRoleNotif(position)"
                        v-model="position"
                      ></v-select>
                    </v-col>

                    <v-col
                      cols="12"
                      sm="5"
                    >
                      <v-select
                        v-model="selectedNotif"
                        :items="itemNotification"
                        chips
                        :rules="nameRules"
                        label="Notification(s)"
                        multiple
                      ></v-select>
                      <v-checkbox
                        class="mt-n2"
                        v-model="checkbox"
                        label="Notification by Location"
                        dense
                      ></v-checkbox>
                    </v-col>

                    <v-col>
                      <v-btn class="float-right ma-4" color="primary" @click="saveNotifRole">
                        Save
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>

                <v-row>
                  <v-col>
                    <h2>Data Setting</h2>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-form ref="dataSetting" lazy-validation>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="5"
                    >
                      <v-select
                        class="mt-4"
                        :items="positions"
                        :rules="nameRules"
                        label="Position"
                        @change="getRoleData(positionData)"
                        v-model="positionData"
                      ></v-select>
                    </v-col>

                    <v-col
                      cols="12"
                      sm="5"
                    >
                      <v-select
                        v-model="selectedPages"
                        :items="itemPages"
                        chips
                        :rules="pageRules"
                        label="Select Page(s)"
                        multiple
                      ></v-select>
                      <v-checkbox
                        class="mt-n2"
                        v-model="checkboxData"
                        label="Data by Location"
                        dense
                      ></v-checkbox>
                    </v-col>

                    <v-col>
                      <v-btn class="float-right ma-4" color="primary" @click="saveDataSetting">
                        Save
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>
          </v-card>
        </v-tab-item>

      </v-tabs-items>
    </v-card>
    </v-col>
  </v-row>
</v-container>
</template>

<script>

import { db }from "../firebase/db.js"
import firebase from "firebase/app"
// import Tiptap from '@/components/TipTap.vue'
// import _ from "lodash";
import axios from "axios"
import { Mentionable } from 'vue-mention'

  export default {
    data : () => ({
      startNotif:'',
      startNotifArray:{
        station:[],
        time:[],
        text:[],
      },
      stopNotif:'',
      stopNotifArray:{
        station:[],
        time:[],
        curah:[],
        text:[],
      },
      notifANotif:'',
      notifANotifArray:{
        station:[],
        time:[],
        curah:[],
        text:[],
      },
      notifCNotif:'',
      notifCNotifArray:{
        station:[],
        time:[],
        curah:[],
        text:[],
      },
      batteryNotif:'',
      batteryNotifArray:{
        station:[],
        time:[],
        text:[],
      },
      turnedOnNotif:'',
      turnedOnNotifArray:{
        station:[],
        time:[],
        text:[],
      },
      suggestionsRain: [
        {
          value: 'station',
          label: 'Stasiun',
        },
        {
          value: 'time',
          label: 'Waktu',
        },
        {
          value: 'curah',
          label: 'Curah',
        },
      ],
      suggestions: [
        {
          value: 'station',
          label: 'Stasiun',
        },
        {
          value: 'time',
          label: 'Waktu',
        },
      ],
      headers: [
        {
          text: 'Email',
          align: 'start',
          value: 'email'
        },
        { text: 'UPTD PSDA', value: 'location', width:'15vW' },
        { text: 'Position', value: 'role' , width: '15vW'},
        { text: 'Confirmed', value: 'confirmed', align: 'end', width: '10vW'},
        { text: 'Delete', value: 'id', width: '8vW', align: 'center'}
      ],
      users:[],
      tab: null,
      items: [
        'User(s)', 'Alarm', 'Notification', 'Role Setting'
      ],
      itemNotification: [
        {text:'Rain Start', value:'start'},
        {text:'Rain Stop', value:'stop'},
        {text:'Notif C', value:'notifc'},
        {text:'Notif A', value:'notifa'},
        {text:'Battery', value:'battery'},
        {text:'Device Status', value:'turnedon'},
      ],
      positions: [],
      locations:['WS CIMANUK - CISANGGARUNG', 'WS CITANDUY', 'WS CIWULAN - CILAKI','WS CISADEA - CIBARENO','WS CITARUM', 'WS CILIWUNG - CISADANE'],
      search:null,
      searchLocation:null,
      roleRequired: [
        v => !!v || 'Role is required',
      ],
      locationRequired: [
        v => !!v || 'Location is required',
      ],
      stations:[],
      selectStation:null,
      station: null,
      phoneNumber:null,
      location: null,
      recapTime: null,
      period: null,
      tickmm: null,
      voltage: null,
      alarmA:null,
      alarmC:null,
      starttick:null,
      stoptime:null,
      valid:false,
      index:null,
      row:0,
      longitude: null,
      latitude:null,
      position:null,
      checkbox:false,
      selectedNotif:null,
      oldValue:{},
      modal2:false,
      nameRules: [
        v => !!v || 'This Field is required'
      ],
      pageRules: [
        v => v.length>0 || 'At least 1 page needs to be selected'
      ],
      number: [
        v => !!v || 'This Field is required',
        v => /^[0-9]*\.?[0-9]*$/.test(v) || 'Only number is allowed'
      ],
      selectedID:null,
      dialogDelete:false,
      emailDelete:null,
      text:'',
      password:'',
      show1:false,
      positionData:null,
      selectedPages:[],
      itemPages:[
        {text:'Peta', value:'Map'},
        {text: 'Peta GPS', value: 'MapGPS'},
        {text:'Kondisi Saat Ini', value:'Condition'},
        {text:'Kondisi Historis', value:'History'},
        {text:'Add Device', value:'AddDevice'},
        {text:'Administrator', value:'Administrator'},
        {text: 'Administrator TMA', value:'AdminTMA'},
        {text:'Notifikasi PCH', value:'Notification'},
        {text:'Notifikasi TMA', value:'NotificationTMA'},
        {text:'Rekapitulasi', value:'Recap'},
        {text:'Grafik Rekapitulasi', value: 'Chart'},
        {text: 'Grafik TMA', value:'ChartTMA'},
        {text: 'Log File', value: 'DownloadFile'},
        {text: 'Log File Bulanan', value: 'DownloadFileMonthly'},
        {text: 'ICCID List', value: 'ICCIDList'},
      ],
      checkboxData: false,
      roleCombobox:null,
      stationA: {
        newID: null,
        feedingID: null
      },
      stationB: {
        newID: null,
        feedingID: null
      },
      swapSnackbar:false,
    }),
    components: {
      // Tiptap
      Mentionable,
    },
    async mounted() {
      let loader = this.$loading.show()
      if (localStorage.getItem("role")=='Petugas') {
        let device = localStorage.getItem('device')
        this.$router.push(`/MapPetugas-id=${device}&device=${localStorage.getItem('jenis')}`)
      }
      var settingRef = db.collection('setting')
      await settingRef.orderBy("station","asc").onSnapshot((collectionSnapshot) => {
        this.stations=[]
        this.data=[]
        collectionSnapshot.forEach((doc) => {  
          if (doc.data().location=='MARNOV') {
            if (localStorage.getItem('location')=='MARNOV') {
              this.stations.push({text: doc.data().station, value: doc.id, newID: doc.data().newID?doc.data().newID:doc.id, feedingID: doc.data().feedingID?doc.data().feedingID:doc.data().newID?doc.data().newID:doc.id});
              this.data.push({id: doc.id, ...doc.data()});
            }
          } else {
            this.stations.push({text: doc.data().station, value: doc.id, newID: doc.data().newID?doc.data().newID:doc.id, feedingID: doc.data().feedingID?doc.data().feedingID:doc.data().newID?doc.data().newID:doc.id});
            this.data.push({id: doc.id, ...doc.data()});
          }
        });
        this.loadingData=false
      })
      // await db.collection('location').doc('locations').onSnapshot((docSnapshot)=> {
      //   this.locations=docSnapshot.data().locations
        db.collection('user').orderBy("confirmed","desc").onSnapshot((collectionSnapshot) => {
          this.users=[]
          collectionSnapshot.forEach((doc) => {
            console.log(doc.id)
            if (doc.id!='role') {
              if (doc.data().email!='Admin@admin.com') {
                this.users.push({id: doc.id,...doc.data()})
              }
            } else {
              this.positions=doc.data().roles
              console.log(this.positions)
            }
          })
          loader.hide()
        })
      // })
      await db.collection('notificationSet').onSnapshot((collectionSnapshot) => {
        collectionSnapshot.forEach((doc) => {
          if (doc.id=='start') {
            this.startNotif=this.textConstructor(doc.data())
          }
          if (doc.id=='stop') {
            this.stopNotif=this.textConstructor(doc.data())
          }
          if (doc.id=='notifA') {
            this.notifANotif=this.textConstructor(doc.data())
          }
          if (doc.id=='notifC') {
            this.notifCNotif=this.textConstructor(doc.data())
          }
          if (doc.id=='turnedOn') {
            this.turnedOnNotif=this.textConstructor(doc.data())
          }
          if (doc.id=='battery') {
            this.batteryNotif=this.textConstructor(doc.data())
          }
        })
      })
    },
    methods: {
      async swapDevice (stationA,stationB) {
        if (stationA.value==stationB.value) {
          alert('Device A and Device B cannot be the same!')
          return
        }
        if (stationA.newID==null || stationB.newID==null) {
          alert('Please fill the new ID for both devices!')
          return
        }

        let loader=this.$loading.show()
        let deviceA=stationA.value
        let deviceB=stationB.value
        let feedingIDA=stationA.feedingID
        let feedingIDB=stationB.feedingID


        let updateNewIDA = null;
        let updateNewIDB = null;
        let lastFeedingIDfeederA = null;
        let lastFeedingIDfeederB = null;
        await db.collection('device').doc(feedingIDA).get().then((doc) => {
          lastFeedingIDfeederA = doc.data().feedingID?doc.data().feedingID:doc.data().newID?doc.data().newID:doc.id
          updateNewIDA = doc.data().newID?doc.data().newID:doc.id     
        })
        await db.collection('device').doc(feedingIDB).get().then((doc) => {
          lastFeedingIDfeederB = doc.data().feedingID?doc.data().feedingID:doc.data().newID?doc.data().newID:doc.id
          updateNewIDB = doc.data().newID?doc.data().newID:doc.id       
        })

        //Tambahin update device doc feedingID update newID jadi dituker
        await db.collection('device').doc(feedingIDA).update({
          feedingID: lastFeedingIDfeederA,
          newID:updateNewIDB,
        }).then(async () => {
          await db.collection('device').doc(feedingIDB).update({
            feedingID: lastFeedingIDfeederB,
            newID:updateNewIDA,
          })
        })
        
        //Tambahin update data feedingID disini
        await db.collection('device').doc(deviceA).update({
          feedingID:feedingIDB
        }).then(async () => {
          await db.collection('device').doc(deviceB).update({
            feedingID:feedingIDA
          })
        })


        let tempDataA = {}
        await db.collection('setting').doc(deviceA).get().then((doc) => {
          tempDataA = {
            infotime: doc.data().infotime,
            mmpertick: doc.data().mmpertick,
            starttick: doc.data().starttick,
            stoptime: doc.data().stoptime,
            batScale: doc.data().batScale,
            latestVersion: doc.data().latestVersion,
            saveSDCard:doc.data().saveSDCard,
            infotime32:doc.data().infotime32,
            latestVersion32: doc.data().latestVersion32,
            requestFile: doc.data().requestFile,
            requestFileTime: doc.data().requestFileTime,
          }
        })

        let tempDataB = {}
        await db.collection('setting').doc(deviceB).get().then((doc) => {
          tempDataB = {
            infotime: doc.data().infotime,
            mmpertick: doc.data().mmpertick,
            starttick: doc.data().starttick,
            stoptime: doc.data().stoptime,
            batScale: doc.data().batScale,
            latestVersion: doc.data().latestVersion,
            saveSDCard:doc.data().saveSDCard,
            infotime32:doc.data().infotime32,
            latestVersion32: doc.data().latestVersion32,
            requestFile: doc.data().requestFile,
            requestFileTime: doc.data().requestFileTime,
          }
        })

        await db.collection('setting').doc(deviceB).update({
          infotime: tempDataA.infotime,
          mmpertick: tempDataA.mmpertick,
          starttick: tempDataA.starttick,
          stoptime: tempDataA.stoptime,
          batScale: tempDataA.batScale,
          latestVersion: tempDataA.latestVersion,
          saveSDCard:tempDataA.saveSDCard,
          infotime32:tempDataA.infotime32,
          latestVersion32: tempDataA.latestVersion32,
          requestFile: tempDataA.requestFile,
          requestFileTime: tempDataA.requestFileTime,
          feedingID: feedingIDA
        })

        await db.collection('setting').doc(deviceA).update({
          infotime: tempDataB.infotime,
          mmpertick: tempDataB.mmpertick,
          starttick: tempDataB.starttick,
          stoptime: tempDataB.stoptime,
          batScale: tempDataB.batScale,
          latestVersion: tempDataB.latestVersion,
          saveSDCard:tempDataB.saveSDCard,
          infotime32:tempDataB.infotime32,
          latestVersion32: tempDataB.latestVersion32,
          requestFile: tempDataB.requestFile,
          requestFileTime: tempDataB.requestFileTime,
          feedingID: feedingIDB
        })

        await db.collection('setting').doc(feedingIDA).update({
          newID:updateNewIDB
        }).then(async () => {
          await db.collection('setting').doc(feedingIDB).update({
            newID:updateNewIDA
          }).then(() => {
            this.swapSnackbar=true
            this.stationA.feedingID= feedingIDB
            this.stationB.feedingID= feedingIDA
            loader.hide()
          })
        })
      },
      change(station) {
        this.index = this.data.findIndex(x => x.id === station.value);
        this.station=station.text
        this.recapTime = this.data[this.index].recap
        this.period = this.data[this.index].infotime
        this.tickmm = this.data[this.index].mmpertick
        this.voltage = this.data[this.index].voltLow
        this.alarmA = this.data[this.index].notifA
        this.alarmC = this.data[this.index].notifC
        this.starttick = this.data[this.index].starttick
        this.stoptime = this.data[this.index].stoptime
        var deviceRef = db.collection('device').doc(station.value)
        deviceRef.get().then((doc) =>{
          this.location=doc.data().location
          this.latitude=doc.data().latitude
          this.longitude=doc.data().longitude
          this.phoneNumber = doc.data().phoneNumber
          this.password = doc.data().password
        }) 
      },
      async save(station) {
        if (this.$refs.form.validate()) {
          let loader=this.$loading.show()
          var deviceRef = db.collection('device').doc(station.value)
          await deviceRef.update({
            location : this.location,
            latitude : this.latitude,
            longitude : this.longitude,
            station: this.station,
            phoneNumber: this.phoneNumber,
            password: this.password
          })
          var settingRef = db.collection('setting').doc(station.value)
          await settingRef.update({
            recap: this.recapTime,
            infotime: this.period,
            mmpertick: this.tickmm,
            voltLow: this.voltage,
            notifA: this.alarmA,
            notifC: this.alarmC,
            starttick: this.starttick,
            stoptime: this.stoptime,
            station: this.station,
            location : this.location,
          }).then (() => {
            loader.hide()
          })
        }
        
      },
      handleClick (row) {
        this.row=this.users.indexOf(row)
      },
      confirm (ID) {
        db.collection('user').doc(ID).update({
          confirmed:true
        }).then(() => {
          console.log("UPDATE")
        })
      },
      Delete(ID) {
        console.log(ID)
        this.dialogDelete=false
        var userRef = db.collection('user')
        axios.post('https://us-central1-rainmonitor-b0968.cloudfunctions.net/Rain/Delete', {
          id: ID
        }).then(function () {
          userRef.doc(ID).delete().then(() => {
            console.log("SUCCESS")
          }).catch((error) => {
            console.log(error)
          })
        })
        .catch(function (error) {
          console.log(error);
        });
      },
      saveNotif() {
        if(this.$refs.notification.validate()) {
          // Get a new write batch
          var batch = db.batch();
          var startRef = db.collection('notificationSet').doc('start')
          batch.set(startRef,{
            station: this.startNotifArray.station,
            time: this.startNotifArray.time,
            text: this.startNotifArray.text
          })
          var stopRef = db.collection('notificationSet').doc('stop')
          batch.set(stopRef,{
            station: this.stopNotifArray.station,
            time: this.stopNotifArray.time,
            curah: this.stopNotifArray.curah,
            text: this.stopNotifArray.text
          })
          var notifARef = db.collection('notificationSet').doc('notifA')
          batch.set(notifARef,{
            station: this.notifANotifArray.station,
            time: this.notifANotifArray.time,
            curah: this.notifANotifArray.curah,
            text: this.notifANotifArray.text
          })
          var notifCRef = db.collection('notificationSet').doc('notifC')
          batch.set(notifCRef,{
            station: this.notifCNotifArray.station,
            time: this.notifCNotifArray.time,
            curah: this.notifCNotifArray.curah,
            text: this.notifCNotifArray.text
          })
          var batteryRef = db.collection('notificationSet').doc('battery')
          batch.set(batteryRef,{
            station: this.batteryNotifArray.station,
            time: this.batteryNotifArray.time,
            text: this.batteryNotifArray.text
          })
          var turnedOnRef = db.collection('notificationSet').doc('turnedOn')
          batch.set(turnedOnRef,{
            station: this.turnedOnNotifArray.station,
            time: this.turnedOnNotifArray.time,
            text: this.turnedOnNotifArray.text
          })
          batch.commit().then(() => {
            console.log("Notification Updated")
          })
        }
      },
      textConstructor(format) {
        let text=''
        let text_length=format.text.length
        if (typeof format.station !== 'undefined') {
          text_length += format.station.length
        }
        if (typeof format.time !== 'undefined') {
          text_length += format.time.length
        }
        if (typeof format.curah !== 'undefined') {
          text_length += format.curah.length
        }

        let textArray=[]
        for (let i=0; i<text_length; i++) {
          let j=0;
          let k=0;
          let l=0;
          if (typeof format.station !== 'undefined') {
            if (i == format.station[j]) {
              textArray.push('@station')
              j++;
            }
          }
          if (typeof format.time !== 'undefined') {
            if (i == format.time[k]) {
              textArray.push('@time')
              k++;
            }
          }
          if (typeof format.curah !== 'undefined') {
            if (i == format.curah[l]) {
              textArray.push('@curah')
              l++;
            }
          }
          textArray.push(format.text[i])
          if (textArray[i]!= undefined) {
            text= text.concat(textArray[i])
          }
          
        }
        return text
      },
      async deleteDevice(ID) {
        await db.collection("device").doc(ID.value).update({
          bat:firebase.firestore.FieldValue.delete(),
          condition:firebase.firestore.FieldValue.delete(),
          location:firebase.firestore.FieldValue.delete(),
          password:firebase.firestore.FieldValue.delete(),
          phoneNumber:firebase.firestore.FieldValue.delete(),
          station:firebase.firestore.FieldValue.delete(),
          time:firebase.firestore.FieldValue.delete(),
          latitude:50,
          longitude:50
        }).then(() => {
            console.log("Document successfully deleted!");
        }).catch((error) => {
            console.error("Error removing document: ", error);
        });
        await db.collection("periodic").doc(ID.value).delete().then(() => {
            console.log("Document successfully deleted!");
        }).catch((error) => {
            console.error("Error removing document: ", error);
        });
        await db.collection("report").doc(ID.value).delete().then(() => {
            console.log("Document successfully deleted!");
        }).catch((error) => {
            console.error("Error removing document: ", error);
        });
        await db.collection("setting").doc(ID.value).update({
          station: firebase.firestore.FieldValue.delete()
        }).then(() => {
            console.log("Document successfully deleted!");
        }).catch((error) => {
            console.error("Error removing document: ", error);
        });
        if (ID.value.includes("BBWS_PCH")) {
          await db.collection("BBWS_Connector").doc("BBWS_PCH").update({
            IDs: firebase.firestore.FieldValue.arrayRemove(ID.value)
          })
        }
      },
      async saveNotifRole() {
        if (this.$refs.notif.validate()) {
          let loader=this.$loading.show()
          await db.collection('roleNotification').doc(this.position).set({
            notif:this.selectedNotif,
            location:this.checkbox
          }).then(() => {
            loader.hide()
            this.selectedNotif=[]
            this.checkbox=false
            this.position=null
          })
        }
      },
      async getRoleNotif(position) {
        await db.collection('roleNotification').doc(position).get().then((doc) => {
          this.selectedNotif = doc.data().notif
          this.checkbox = doc.data().location
        })
      },
      async getRoleData(position) {
        await db.collection('roleSetting').doc(position).get().then((doc) => {
          this.selectedPages=doc.data().page
          this.checkboxData=doc.data().location
        })
      },
      async saveDataSetting() {
        if (this.$refs.dataSetting.validate()) {
          let loader= this.$loading.show()
          await db.collection('roleSetting').doc(this.positionData).set({
            location:this.checkboxData,
            page:this.selectedPages
          }).then(() => {
            this.checkboxData=false
            this.selectedPages=[]
            loader.hide()
          }).catch(() => {
            loader.hide()
          })
        }
        
      },
      async saveRole(ID,role) {
        let loader= this.$loading.show()
        await db.collection('user').doc(ID).update({
          role:role
        }).then(() => {
          loader.hide()
        }).catch(() => {
          loader.hide()
        })
      },
      async saveLocation(ID,location) {
        let loader= this.$loading.show()
        await db.collection('user').doc(ID).update({
          location:location
        }).then(() => {
          loader.hide()
        }).catch(() => {
          loader.hide()
        })
      },
      filterItems(arr, query) {
        return arr.filter(function(el) {
          console.log(el)
          return (el.toLowerCase().indexOf(query.toLowerCase()) !== -1)
        })
      },
      async deleteRole (role) {
        let found = this.users.findIndex(x=> x.role === role)
        // No user with the selected role
        if (found==-1) {
          let index = this.positions.findIndex(x=> x===role)
          this.positions.splice(index,1)
          let loader=this.$loading.show()
          await db.collection("user").doc('role').update({
            roles:this.positions
          }).catch(() => {
            loader.hide()
          });
          await db.collection('roleNotification').doc(role).delete().catch(()=> {
            loader.hide()
          })
          await db.collection('roleSetting').doc(role).delete().then(() => {
            loader.hide()
          }).catch(() => {
            loader.hide()
          })
        } else {
          alert('Terdapat user yang memiliki role tersebut!')
        }
      }
    },
    watch: {
      startNotif(val) {
        this.startNotifArray.text=val.split('@')
        this.startNotifArray.station=[]
        this.startNotifArray.time=[]
        for (let i=0; i<this.startNotifArray.text.length; i++) {
          if (this.startNotifArray.text[i].startsWith("station")) {
            this.startNotifArray.text[i]=this.startNotifArray.text[i].slice(7)
            this.startNotifArray.station.push(i)
          }
          if (this.startNotifArray.text[i].startsWith("time")) {
            this.startNotifArray.text[i]=this.startNotifArray.text[i].slice(4)
            this.startNotifArray.time.push(i)
          }
        }
      },
      stopNotif(val) {
        this.stopNotifArray.text=val.split('@')
        this.stopNotifArray.station=[]
        this.stopNotifArray.time=[]
        this.stopNotifArray.curah=[]
        for (let i=0; i<this.stopNotifArray.text.length; i++) {
          if (this.stopNotifArray.text[i].startsWith("station")) {
            this.stopNotifArray.text[i]=this.stopNotifArray.text[i].slice(7)
            this.stopNotifArray.station.push(i)
          }
          if (this.stopNotifArray.text[i].startsWith("time")) {
            this.stopNotifArray.text[i]=this.stopNotifArray.text[i].slice(4)
            this.stopNotifArray.time.push(i)
          }
          if (this.stopNotifArray.text[i].startsWith("curah")) {
            this.stopNotifArray.text[i]=this.stopNotifArray.text[i].slice(5)
            this.stopNotifArray.curah.push(i)
          }
        }
      },
      notifANotif(val) {
        this.notifANotifArray.text=val.split('@')
        this.notifANotifArray.station=[]
        this.notifANotifArray.time=[]
        this.notifANotifArray.curah=[]
        for (let i=0; i<this.notifANotifArray.text.length; i++) {
          if (this.notifANotifArray.text[i].startsWith("station")) {
            this.notifANotifArray.text[i]=this.notifANotifArray.text[i].slice(7)
            this.notifANotifArray.station.push(i)
          }
          if (this.notifANotifArray.text[i].startsWith("time")) {
            this.notifANotifArray.text[i]=this.notifANotifArray.text[i].slice(4)
            this.notifANotifArray.time.push(i)
          }
          if (this.notifANotifArray.text[i].startsWith("curah")) {
            this.notifANotifArray.text[i]=this.notifANotifArray.text[i].slice(5)
            this.notifANotifArray.curah.push(i)
          }
        }
      },
      notifCNotif(val) {
        this.notifCNotifArray.text=val.split('@')
        this.notifCNotifArray.station=[]
        this.notifCNotifArray.time=[]
        this.notifCNotifArray.curah=[]
        for (let i=0; i<this.notifCNotifArray.text.length; i++) {
          if (this.notifCNotifArray.text[i].startsWith("station")) {
            this.notifCNotifArray.text[i]=this.notifCNotifArray.text[i].slice(7)
            this.notifCNotifArray.station.push(i)
          }
          if (this.notifCNotifArray.text[i].startsWith("time")) {
            this.notifCNotifArray.text[i]=this.notifCNotifArray.text[i].slice(4)
            this.notifCNotifArray.time.push(i)
          }
          if (this.notifCNotifArray.text[i].startsWith("curah")) {
            this.notifCNotifArray.text[i]=this.notifCNotifArray.text[i].slice(5)
            this.notifCNotifArray.curah.push(i)
          }
        }
      },
      batteryNotif(val) {
        this.batteryNotifArray.text=val.split('@')
        this.batteryNotifArray.station=[]
        this.batteryNotifArray.time=[]
        for (let i=0; i<this.batteryNotifArray.text.length; i++) {
          if (this.batteryNotifArray.text[i].startsWith("station")) {
            this.batteryNotifArray.text[i]=this.batteryNotifArray.text[i].slice(7)
            this.batteryNotifArray.station.push(i)
          }
          if (this.batteryNotifArray.text[i].startsWith("time")) {
            this.batteryNotifArray.text[i]=this.batteryNotifArray.text[i].slice(4)
            this.batteryNotifArray.time.push(i)
          }
        }
      },
      turnedOnNotif(val) {
        this.turnedOnNotifArray.text=val.split('@')
        this.turnedOnNotifArray.station=[]
        this.turnedOnNotifArray.time=[]
        for (let i=0; i<this.turnedOnNotifArray.text.length; i++) {
          if (this.turnedOnNotifArray.text[i].startsWith("station")) {
            this.turnedOnNotifArray.text[i]=this.turnedOnNotifArray.text[i].slice(7)
            this.turnedOnNotifArray.station.push(i)
          }
          if (this.turnedOnNotifArray.text[i].startsWith("time")) {
            this.turnedOnNotifArray.text[i]=this.turnedOnNotifArray.text[i].slice(4)
            this.turnedOnNotifArray.time.push(i)
          }
        }
      },
      async roleCombobox (val, prev) {
        val = val != null ? val : ''
        prev = prev != null ? prev : ''
        if (val.length === prev.length) return
        if (val!== '') {
          if (this.filterItems(this.positions,val).length==0) {
            if (val!=null) {
              this.positions.push(val)
              await db.collection('roleNotification').doc(val).set({
                location:false,
                notif:['start','stop','notifc','notifa','battery','turnedon']
              })
              await db.collection('roleSetting').doc(val).set({
                location:false,
                page:['Map','Condition','History','Notification','Recap']
              })
            }
            var userRef = db.collection('user')
            if (this.positions.indexOf(null)===-1) {
              await userRef.doc('role').set({
                roles:this.positions,
                confirmed:true
              })
            }
          }
        }
      }
    }
  }
</script>

<style lang="scss">
.tooltip {
  display: block !important;
  z-index: 10000;
  position:'bottom-end';
  .tooltip-inner {
    background: black;
    color: white;
    border-radius: 16px;
    padding: 5px 10px 4px;
  }
  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 50px;
    border-color: black;
    z-index: 1;
  }
  &[x-placement^="top"] {
    margin-bottom: 5px;
    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }
  &[x-placement^="bottom"] {
    margin-top: 5px;
    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }
  &[x-placement^="right"] {
    margin-left: 5px;
    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }
  &[x-placement^="left"] {
    margin-right: 5px;
    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }
  &[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
  }
  &[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
  }
  &.info {
    $color: rgba(#004499, .9);
    .tooltip-inner {
      background: $color;
      color: white;
      padding: 24px;
      border-radius: 5px;
      box-shadow: 0 5px 30px rgba(black, .1);
    }
    .tooltip-arrow {
      border-color: $color;
    }
  }
  &.popover {
    $color: #3949ab;
    .popover-inner {
      background: $color;
      color: rgb(255, 255, 255);
      padding: 4px;
      border-radius: 5px;
      box-shadow: 0 5px 30px rgba(black, .1);
    }
    .popover-arrow {
      border-color: $color;
    }
  }
  
}
</style>

<style>
.mention-item {
  padding: 4px 10px;
  border-radius: 4px;
}

.mention-selected {
  background:#6875bf;
}
</style>
